module.exports = __webpack_public_path__ + "static/media/Aveny soffa D32R zink 3493 detalj 2023 1 fyrkant.0dd3c038.jpg";